import { Record, List } from 'immutable';
import { EntityTypes } from '../schemas';

export default class UserRecord extends Record({
  id: undefined,
  createdAt: undefined,
  name: '',
  firstName: undefined,
  lastName: undefined,
  email: '',
  langCode: undefined,
  languages: undefined,
  selectedLanguage: undefined,
  customerOrderConfirmationEmail: undefined,
  resourceOrderConfirmationEmail: undefined,
  enabled: null,
  budget: undefined,
  phone: undefined,
  password: null,
  roles: undefined,
  setting: {
    preferredServiceId: undefined,
  },
  staffingCompanyGroup: undefined,
  receiveInternalEmails: false,
  receiveCancelledPeriodsEmails: false,
  receiveProspectCreatedEmails: false,
  receiveVacancyInterestEmails: false,
  twoFactorAuthMode: null,
  receiveInquiryEmails: undefined,
  links: new List(),
  feature: undefined,
  unoId: undefined,
  modules: undefined,
  settings: null,
  type: EntityTypes.User,
}) {
}
